<template>

    <input class="block
            ring-0 outline-none focus:ring-blue border-0
            placeholder-blue placeholder-opacity-80
            text-lg font-nexa text-blue
            rounded-xl px-6 pt-5 pb-4"
           :value="modelValue"
           @input="$emit('update:modelValue', $event.target.value)"
           ref="input" />

</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    props: ['modelValue'],

    emits: ['update:modelValue'],

    methods: {
        focus() {
            this.$refs.input.focus()
        }
    }
})
</script>
